import { Toast } from "vant";
export const forEach = (arr, fn) => {
    if (!arr.length || !fn) return;
    let i = -1;
    let len = arr.length;
    while (++i < len) {
        let item = arr[i];
        fn(item, i, arr);
    }
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
    let len = Math.min(arr1.length, arr2.length);
    let i = -1;
    let res = [];
    while (++i < len) {
        const item = arr2[i];
        if (arr1.indexOf(item) > -1) res.push(item);
    }
    return res;
};

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
    return Array.from(new Set([...arr1, ...arr2]));
};

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
    return targetarr.some((_) => arr.indexOf(_) > -1);
};

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf(value, validList) {
    for (let i = 0; i < validList.length; i++) {
        if (value === validList[i]) {
            return true;
        }
    }
    return false;
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = (timeStamp) => {
    const timeStr = String(timeStamp);
    return timeStr.length > 10;
};

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
    return timeStamp < currentTime;
};

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = (num) => {
    return num < 10 ? "0" + num : num;
};

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
const getDate = (timeStamp, startType) => {
    const d = new Date(timeStamp * 1000);
    const year = d.getFullYear();
    const month = getHandledValue(d.getMonth() + 1);
    const date = getHandledValue(d.getDate());
    const hours = getHandledValue(d.getHours());
    const minutes = getHandledValue(d.getMinutes());
    const second = getHandledValue(d.getSeconds());
    let resStr = "";
    if (startType === "year") resStr = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + second;
    else resStr = month + "-" + date + " " + hours + ":" + minutes;
    return resStr;
};

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = (timeStamp) => {
    // 判断当前传入的时间戳是秒格式还是毫秒
    const IS_MILLISECOND = isMillisecond(timeStamp);
    // 如果是毫秒格式则转为秒格式
    if (IS_MILLISECOND) Math.floor((timeStamp /= 1000));
    // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
    timeStamp = Number(timeStamp);
    // 获取当前时间时间戳
    const currentTime = Math.floor(Date.parse(new Date()) / 1000);
    // 判断传入时间戳是否早于当前时间戳
    const IS_EARLY = isEarly(timeStamp, currentTime);
    // 获取两个时间戳差值
    let diff = currentTime - timeStamp;
    // 如果IS_EARLY为false则差值取反
    if (!IS_EARLY) diff = -diff;
    let resStr = "";
    const dirStr = IS_EARLY ? "前" : "后";
    // 少于等于59秒
    if (diff <= 59) resStr = diff + "秒" + dirStr;
    // 多于59秒，少于等于59分钟59秒
    else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + "分钟" + dirStr;
    // 多于59分钟59秒，少于等于23小时59分钟59秒
    else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + "小时" + dirStr;
    // 多于23小时59分钟59秒，少于等于29天59分钟59秒
    else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + "天" + dirStr;
    // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
    else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp);
    else resStr = getDate(timeStamp, "year");
    return resStr;
};

/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
    const ua = window.navigator.userAgent;
    const isExplorer = (exp) => {
        return ua.indexOf(exp) > -1;
    };
    if (isExplorer("MSIE")) return "IE";
    else if (isExplorer("Firefox")) return "Firefox";
    else if (isExplorer("Chrome")) return "Chrome";
    else if (isExplorer("Opera")) return "Opera";
    else if (isExplorer("Safari")) return "Safari";
};

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
    if (document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.attachEvent("on" + event, handler);
            }
        };
    }
})();

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
    if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent("on" + event, handler);
            }
        };
    }
})();

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
    if (key) return key in obj;
    else {
        let keysArr = Object.keys(obj);
        return keysArr.length;
    }
};

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
    const keysArr1 = Object.keys(obj1);
    const keysArr2 = Object.keys(obj2);
    if (keysArr1.length !== keysArr2.length) return false;
    else if (keysArr1.length === 0 && keysArr2.length === 0) return true;
    /* eslint-disable-next-line */ else return !keysArr1.some((key) => obj1[key] != obj2[key]);
};

/**
 * 复制
 */
export const copyText = (text) => {
    // 数字没有 .length 不能执行selectText 需要转化成字符串
    const textString = text.toString();
    let input = document.querySelector("#copyInput");
    if (!input) {
        input = document.createElement("input");
        input.id = "copy-input";
        input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input);
    }

    input.value = textString;
    // ios必须先选中文字且不支持 input.select();
    selectText(input, 0, textString.length);
    console.log(document.execCommand("copy"), "execCommand");
    if (document.execCommand("copy")) {
        document.execCommand("copy");
    }
    input.blur();

    // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
    // 选择文本。createTextRange(setSelectionRange)是input方法
    function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {
            //ie
            const range = textbox.createTextRange();
            range.collapse(true);
            range.moveStart("character", startIndex); //起始光标
            range.moveEnd("character", stopIndex - startIndex); //结束光标
            range.select(); //不兼容苹果
        } else {
            //firefox/chrome
            textbox.setSelectionRange(startIndex, stopIndex);
            textbox.focus();
        }
    }
};

/**
 * 是否是微信浏览器
 */
export const isWechat = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("micromessenger") > -1;
};

/**
 * 是否是闽政通webview
 */
export const isMzt = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("mzt") > -1;
};

/**
 * 是否是闽政通webview
 */
export const isCstoon = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("innoApp") > -1;
};
/**
 * 是否是云闪付App webview
 */
export const isUnionApp = () => {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf("UnionPay/1.0 CloudPay") > -1;
};
/**
 * 是否是支付宝 webView
 */
export const isAliPay = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf("alipayclient") > -1;
};

export const payEnv = () => {
    if (isAliPay()) {
        return {
            payChannel: "alipay",
            appEnv: "支付宝APP",
        };
    } else if (isUnionApp()) {
        return {
            payChannel: "unionscanpay",
            appEnv: "云闪付APP",
        };
        return [];
    } else if (isWeixin()) {
        return {
            payChannel: "wxpay",
            appEnv: "微信APP",
        };
    } else {
        return false;
    }
};

/**
 * 给小于10一位数字补成两位
 * @param {String,Number} num 字符串数字
 */
export const one2two = (num) => {
    if (typeof num == "number") {
        return String(num).length == 1 ? "0" + num : num;
    } else if (typeof num == "string") {
        return num.length == 1 ? "0" + num : num;
    }
};

/**
 * 将秒转成分钟，多一秒则进一
 * @param {*} second 秒
 * @returns
 */
export const secondToMinute = (second) => {
    let minute = Math.floor(second / 60);
    return second % 60 > 0 ? minute + 1 : minute;
};

/**
 * 防抖函数
 * @param {Function} fn 函数
 * @param {Number} wait 时间
 * @returns 函数
 */
export const debounce = (fn, wait) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        //跟 throttle 比多了个重置时间
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            fn.apply(context, args);
            timer = null;
        }, wait);
    };
};

/**
 * 节流函数
 * @param {Function} fn 函数
 * @param {Number} wait 时间
 * @returns 函数
 */
export const throttle = (fn, wait) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        if (!timer) {
            timer = setTimeout(function () {
                fn.apply(context, args);
                timer = null;
            }, wait);
        }
    };
};

/**
 * 节流函数
 * @param {Function} fn 函数
 * @param {Number} wait 时间
 * @returns 函数
 */
export const throttleBytimestamp = (fn, wait) => {
    var pre = Date.now();
    return function () {
        var context = this;
        var args = arguments;
        var now = Date.now();
        if (now - pre >= wait) {
            fn.apply(context, args);
            pre = Date.now();
        }
    };
};

/**
 * 百度坐标转高德坐标
 * @param {Number} gd_lng 经度
 * @param {Number} gd_lat 纬度
 * @returns {Object} { 经度,纬度 }
 */
export const bd_decrypt = (bLng, bLat) => {
    let X_PI = (Math.PI * 3000.0) / 180.0;
    let x = bLng - 0.0065;
    let y = bLat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    let gLng = z * Math.cos(theta);
    let gLat = z * Math.sin(theta);
    return { lng: gLng, lat: gLat };
    // return [gLng, gLat]
};
/**
 * 高德坐标转百度（传入经度、纬度）
 * @param {Number} gd_lng 经度
 * @param {Number} gd_lat 纬度
 * @returns {Object} { 经度,纬度 }
 */
export const bd_encrypt = (gd_lng, gd_lat) => {
    let X_PI = (Math.PI * 3000.0) / 180.0;
    let x = gd_lng,
        y = gd_lat;
    let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
    let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
    let bd_lng = z * Math.cos(theta) + 0.0065;
    let bd_lat = z * Math.sin(theta) + 0.006;
    return { lat: bd_lat, lng: bd_lng };
};

/**
 * 图片上传前回调
 * @param {*} file
 * @returns {Boolean} 返回是否可以上传的标志
 */
export const beforeRead = (file) => {
    if (file.type != "image/jpeg" && file.type !== "image/png") {
        Toast("请上传 jpg、png 格式图片");
        return false;
    }

    if (file.type > 8 * 1024 * 1024 * 10) {
        Toast("上传的图片不得大于10MB");
        return false;
    }
    return true;
};

/**
 * 转化车牌号 闽E88888 => 闽E 88888
 * @param {String} code
 * @returns 转化后的车牌
 */
export const parseCarCode = (code) => {
    return code.slice(0, 2) + " " + code.slice(2);
};

/**
 * 判断当前浏览器环境是否是微信浏览器
 * @returns {Boolean} 标志
 */
export const isWeixin = () => {
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
        return true;
    } else {
        return false;
    }
};

/**
 * 将文件转成base64
 */
export const fileToBase64 = (file, callback) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((resolve, reject) => {
        reader.onloadend = function (e) {
            let base64 = e.target.result;
            resolve(base64);
        };
    });
};

/**
 * 将对象转成param
 * @param {Object} obj
 */
export const obj2Param = (obj) => {
    return Object.keys(obj)
        .map((key) => {
            return key + "=" + obj[key];
        })
        .join("&");
};

export const closePage = () => {
    if (navigator.userAgent.indexOf("Firefox") != -1 || navigator.userAgent.indexOf("Chrome") != -1) {
        window.location.href = "about:blank";

        window.close();
    } else {
        window.opener = null;

        window.open("", "_self");

        window.close();
    }
};
